import { put, takeLatest } from 'redux-saga/effects';
import { signup, signin, success, failed } from '../slice/userSlice';
import { postRequest } from './ApiInstence';

function* signinUser({ payload }) {
  try {
    let response = yield postRequest('admin/signin', payload);
    if (response && response.status === 200) {
      yield put(success(response));
    } else {
      yield put(failed(response || { message: 'Authentication failed' }));
    }
  } catch (error) {
    yield put(failed(error));
  }
}

function* signupUser({ payload }) {
  try {
    const response = yield postRequest('register', payload);
    if (response && response.status === 200) {
      yield put(success(response.data));
    } else {
      yield put(failed(response));
    }
  } catch (error) {
    yield put(failed(error));
  }
}

export function* watchGetUser() {
  yield takeLatest(signin.type, signinUser);
  yield takeLatest(signup.type, signupUser);
}